


















import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import 'pc-bootstrap4-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import moment from "moment";

@Component({})
export default class DateEditor extends Vue {
   $datetimepicker;

   @Prop() value!: Date;
   @Prop({default: false}) disabledProp!: boolean;
   @Prop({default: false}) prependDialog!: boolean;
   @Prop({}) selectedOption!: string;
   @Prop({default: false}) showPicker!: boolean;
   @Prop({default: false}) invalidDate!: boolean;
   @Prop() hideIcon!: boolean;

    selectedChanged(val) {
       this.$emit('changeEvent', val);
   }

    @Watch('value') onValueChanged(value) {
        this.$datetimepicker.datetimepicker('date', value || null);
    }

   mounted() {
        this.$datetimepicker = $(this.getReference()).datetimepicker({
            format: 'DD.MM.YYYY',
            parseInputDate: this.parser,
            date: this.value,
        });
        this.$datetimepicker.on('dp.change', e => {
            const d = moment(e.date);
            this.input(d.isValid() ? d.toDate() : null);
        });

   }

   @Emit() input(value: Date) {}

   open() {
       this.$datetimepicker.datetimepicker('show');
   }

   selectAll() {
       (<any>this.getReference()).select();
   }

   getReference() {
       return <HTMLElement>this.$refs['datetimepicker'];
   }

   destroyed() {
       this.$datetimepicker.datetimepicker('destroy');
   }

   parser(inputDate) {
       let resultDate;

       if (moment.isMoment(inputDate) || inputDate instanceof Date) {
           const date = moment(inputDate);
           resultDate = date.isValid() ? date : null;
       } else {
          let pattern =  /\d{2}[\.|-]{0,1}\d{2}[\.-]{0,1}\d{4}[\.-]{0,1}/;
          if (pattern.test(inputDate)) {
              inputDate = inputDate.replace('.', '').replace('-', '');
              return moment(inputDate, 'DDMMYYYY').add(2, 'hour');
          }
          pattern = /\d{2}[\.|-]{0,1}\d{2}[\.-]{0,1}/;
          if (pattern.test(inputDate)) {
              inputDate = inputDate.replace('.', '').replace('-', '');
              return moment(inputDate, 'DDMM').add(2, 'hour');
          }
       }

       return resultDate;
   }
}
